import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { SpinnerFullPage } from 'shared/components/SpinnerFullPage/index.js';
import { getUrlToLoginPage } from "../urls";
import { clearUserToken } from 'api/auth-storage';

const LOGIN_PAGE_URL = getUrlToLoginPage();

export function LogoutPage() {
  const navigate = useNavigate();
  const [urlSearchParams] = useSearchParams();

  const redirectAfterLogout = urlSearchParams.has('redirectAfterLogout');
  const redirectTo = urlSearchParams.get('redirectTo')

  const redirectUrl = redirectTo && redirectAfterLogout
    ? redirectTo
    : LOGIN_PAGE_URL + '?' + urlSearchParams.toString();

  useEffect(() => {
    clearUserToken();
    if (redirectAfterLogout) window.location.replace(redirectUrl);
    else navigate(redirectUrl, { replace: true });
  }, [navigate, redirectAfterLogout, redirectUrl]);
  return <SpinnerFullPage />;
}
